module.exports = __webpack_public_path__ + "img/Miscellaneous.6156306a.svg";